import React from 'react';
import AppsByCategoryTagHeader from './AppsByCategoryTagHeader';
import { filterProjectsByTag } from './filter';
import SolutionCards from './SolutionCards';

function AllLibraryAppsByCategory({ tags, projects, accessedFromWorkspace, onProjectSelect, onUseAppClick, onSeeAllClick , userRole, user }) {
    return (
        <div className='container-fluid'>
            {
                tags.map((tag, index) => (
                    <ListOfThreeProjectWithSameTag
                        key={tag + "-" + index}
                        projects={projects}
                        tag={tag}
                        userRole={userRole}
                        user={user}
                        accessedFromWorkspace={accessedFromWorkspace}
                        onProjectSelect={onProjectSelect}
                        onUseAppClick={onUseAppClick}
                        onSeeAllClick={onSeeAllClick}
                    />
                ))
            }
        </div>
    );
}

function ListOfThreeProjectWithSameTag({ projects, tag, accessedFromWorkspace, onProjectSelect, onUseAppClick, onSeeAllClick, userRole, user }) {
    const projectsWithSameTags = filterProjectsByTag(projects, tag);

    return (
        <>
            <AppsByCategoryTagHeader
                tag={tag}
                numberOfProjects={projectsWithSameTags.length}
                onSeeAllClick={onSeeAllClick} />
            <div className='row'>
                {
                    projectsWithSameTags.slice(0, 3).map((project) => (
                        <div className='col-4' key={project.id}>
                            <SolutionCards
                                user={user}
                                userRole={userRole}
                                solution={project}
                                selectSolutions={() => onProjectSelect(project)}
                                isShowFromRuntime={accessedFromWorkspace}
                                onCreate={onUseAppClick}
                                UseSolutionTemplate={onUseAppClick} />
                        </div>
                    ))
                }
            </div>
        </>
    );
}

export default AllLibraryAppsByCategory;